export type ConfiguratorVariantOption = {
  name: string;
  type: string;
  options: string[] | ConfiguratorVariantOption[];
  selected?: string | ConfiguratorVariantOption;
  url?: string;
};

/** fetchMaterialOptions API'sinden gelen kumaş/renk görsel seçenekleri */
export type MaterialOption = {
  name: string;
  url: string;
};

export type ConfiguratorVariant = {
  variantId?: string;
  name: string;
  explanation: string;
  urlHandle?: string;
  productId?: string;
  /** armType, legType, legColor, fabricType, fabricColor, backCushion, blockType, size vb. */
  attributes: Record<string, string>;
};

export const getVariantAttr = (
  v: ConfiguratorVariant,
  key: string
): string | undefined => v.attributes?.[key];

export const setVariantAttr = (
  v: ConfiguratorVariant,
  key: string,
  value: string
): void => {
  if (!v.attributes) v.attributes = {};
  v.attributes[key] = value;
};

export type ConfiguratorVariantModule = ConfiguratorVariantOption & {
  variant: ConfiguratorVariant;
  /** API'den null gelir; optionDetails _optionDetails Map'ine materialOptions'tan doldurulur */
  optionDetails: ConfiguratorVariantOption[] | null;
};

export type CONFIGURATOR_MODEL_TYPE = {
  name: string;
  configurator: CONFIGURATOR_TYPE;
  models: MODEL_TYPE[];
  materialPartGroups: {
    title: string;
    code: string;
    materialGroups: { name: string; order: number; materials: any[] }[];
  }[];
};

export type CONFIGURATOR_TYPE = {
  excludeModels?: number[];
  backs?: MODEL_PART_TYPE[];
  legs?: MODEL_PART_TYPE[];
  sides?: MODEL_PART_TYPE[];
  events?: EVENT_TYPE[];
  /** İç genişlik (cm) → yüklenecek model id listesi */
  sizes?: Record<number, number[]>;
  /** Varyant `body` string değeri → yüklenecek model id listesi */
  body?: Record<string, number[]>;
  /**
   * `materialPartGroups[].code` — kumaş/renk eşlemesi bu grupta aranır.
   * Yoksa başlık anahtar kelimesi veya son çare `"1"`.
   */
  fabricMaterialGroupCode?: string;
  /**
   * `materialPartGroups[].code` — ayak rengi bu grupta aranır.
   * Yoksa başlık anahtar kelimesi veya son çare `"2"`.
   */
  legMaterialGroupCode?: string;
};

export type MODEL_PART_TYPE = {
  name: string;
  type: string;
  imageURL: string;
  joints: JOINT_TYPE[];
  match: number | number[];
};

export type JOINT_TYPE = {
  name: string;
  type: string;
  match: number | Record<string, number>;
  id?: number;
};

export type EVENT_TYPE = {
  when: { type: string; items: number[] };
  operations: { action: string; parameters?: Record<string, any> }[];
};

export type MODEL_TYPE = {
  id: number;
  name: string;
  gltf: string;
  thumbnailFileUrl: string;
  replaceType: number;
  moveType: number;
  parts: any[];
  partMaterialGroups: any[];
  jointInfo: any;
  price?: number | null;
  x: number | null;
  y: number | null;
  z: number | null;
  centerX?: number | null;
  centerY?: number | null;
  centerZ?: number | null;
  orderIndex: number;
};

function createDefaultData(): CONFIGURATOR_MODEL_TYPE {
  return {
    name: "Default",
    configurator: {
      excludeModels: [],
      backs: [],
      sides: [],
      legs: [],
      events: [],
      sizes: {},
      body: {},
    },
    models: [],
    materialPartGroups: [],
  };
}

const _store = new Map<string, CONFIGURATOR_MODEL_TYPE>();

export function getConfiguratorData(id: string): CONFIGURATOR_MODEL_TYPE {
  let data = _store.get(id);
  if (!data) {
    data = createDefaultData();
    _store.set(id, data);
  }
  return data;
}

export function setConfiguratorData(
  id: string,
  incoming: Partial<CONFIGURATOR_MODEL_TYPE>,
): CONFIGURATOR_MODEL_TYPE {
  const data = getConfiguratorData(id);
  if (incoming.name !== undefined) data.name = incoming.name;
  if (incoming.configurator !== undefined) data.configurator = incoming.configurator;
  if (incoming.models !== undefined) data.models = incoming.models;
  if (incoming.materialPartGroups !== undefined) data.materialPartGroups = incoming.materialPartGroups;
  return data;
}

export function removeConfiguratorData(id: string): boolean {
  return _store.delete(id);
}

/**
 * @deprecated Geriye dönük uyumluluk için. Yeni kodda getConfiguratorData(id) kullanın.
 */
export const CONFIGURATOR_DATA: CONFIGURATOR_MODEL_TYPE = getConfiguratorData("default");

export * from "./ConfiguratorModule.js";